const getDefaultSettings = (trans) => {
  return {
    myPackHome: {
      title: trans.myPackHomeTitle,
      rate: 60,
      description: trans.myPackHomeDesc,
    },
    myPackCollect: {
      title: trans.myPackCollectTitle,
      rate: 45,
      description: trans.myPackCollectDesc,
    },
    customerNumber: "",
  };
};

export const getAppSettings = (trans) => {
  return new Promise((resolve) => {
    try {
      EcwidApp.getAppStorage("settings", (settings) => {
        const parsedSettings = settings ? JSON.parse(settings) : getDefaultSettings(trans);
        resolve(parsedSettings);
      });
    } catch (e) {
      console.warn("Error loading config", e.message);
      resolve(getDefaultSettings(trans));
    }
  });
};

export const setAppSettings = (settings, trans) => {
  return getAppSettings(trans).then((curSettings) => {
    const newSettings = {
      ...curSettings,
      ...settings,
      myPackHome: {
        ...curSettings.myPackHome,
        ...(settings.myPackHome || {}),
      },
      myPackCollect: {
        ...curSettings.myPackCollect,
        ...(settings.myPackCollect || {}),
      },
    };
    return new Promise((resolve) => {
      EcwidApp.setAppStorage({ settings: JSON.stringify(newSettings) }, () => {
        resolve(newSettings);
      });
    });
  });
};
